import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ROUTES from '../constants/routes';

/**
 * PrivateRoute component to protect routes that require authentication
 * If user is not authenticated, redirects to login page with redirect back to original route
 */
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const location = useLocation();

  // Show loading state if authentication status is being checked
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to login with return path
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location.pathname }} replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default PrivateRoute; 